import axios from '../helpers/axios'
import { IPrintSeriesBrochures } from '../models';
import { logError } from '../services';

export const getPlanSeriesBrochures = async (
  planStyleId: number | string
): Promise<any> => {
  try {
    const { data } = await axios.get(`/api/series-brochures/${planStyleId}/plan-options`);
    return data;
  } catch (error) {
    logError(error, 'getPlanRooms failed');
    return Promise.reject(error?.response?.data);
  }
};

export const createPlanSeriesBrochures = async (
  payload: IPrintSeriesBrochures
): Promise<any> => {
  try {
    const { data } = await axios.post(`/api/series-brochures/`, payload);
    return data;
  } catch (error) {
    logError({ error, payload: payload }, 'createPlanSeriesBrochures failed');
    return Promise.reject(error?.response?.data);
  }
};